import { Box, Chip, Typography } from '@mui/material'

import ToothGraphic4 from '@/assets/images/Tooth-graphic-4.svg'
import PieChart from '@/components/PieChart'
import {
  ALL_IN_ONE_REGIONS,
  dentinLayerView,
  getAllInOneCeramicBrand,
  getDentinLayerAdvice,
  hasDentinAdvice,
} from '@/utils/matisseV2/allInOne'

const DentinLayerAdvice = ({
  recipe,
  dentinCervicalIndex,
  dentinMiddleIndex,
  dentinIncisalIndex,
}) => {
  const brand = getAllInOneCeramicBrand(recipe)
  const indexes = {
    cervical: dentinCervicalIndex,
    middle: dentinMiddleIndex,
    incisal: dentinIncisalIndex,
  }
  const titles = {
    cervical: 'Cervical',
    middle: 'Middle',
    incisal: 'Incisal',
  }

  const renderSection = (region: 'cervical' | 'middle' | 'incisal') => {
    const data = getDentinLayerAdvice(recipe, region)
    const index = indexes[region]
    const title = titles[region]
    const layer1 = dentinLayerView(data?.recipe_layer1?.[index])
    const layer2 = dentinLayerView(data?.recipe_layer2?.[index])

    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        width="150px"
        mx={1}
        color="black"
      >
        {data?.recipe_layer1?.[index] && (
          <>
            <Typography
              sx={{ color: 'black', fontWeight: 'bold', textAlign: 'center' }}
            >
              {title}
            </Typography>
            {layer1.opacityCategory && (
              <Typography
                align="center"
                textTransform="capitalize"
                sx={{ fontWeight: 'bold', color: 'black' }}
              >
                {layer1.opacityCategory}
              </Typography>
            )}
            <PieChart
              labels={layer1.names}
              values={layer1.ratios as number[]}
            />
          </>
        )}

        {data?.recipe_layer2?.[index] && (
          <>
            {layer2.opacityCategory && (
              <Typography
                align="center"
                textTransform="capitalize"
                sx={{ fontWeight: 'bold', color: 'black' }}
              >
                {layer2.opacityCategory}
              </Typography>
            )}
            <PieChart
              labels={layer2.names}
              values={layer2.ratios as number[]}
            />
          </>
        )}
      </Box>
    )
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      flexGrow={1}
      px={5}
      sx={{ backgroundColor: '#FFF' }}
      id="download-page-2"
    >
      {hasDentinAdvice(recipe) && (
        <Box display="flex" alignItems="center">
          <Box display="flex" width="30%">
            <img
              src={ToothGraphic4}
              alt="Toothimage"
              style={{ width: 233, height: 330 }}
            />
          </Box>

          <Box width="70%">
            <Box display="flex" alignItems="center" m={2}>
              <Typography variant="h5" sx={{ color: 'black' }}>
                Dentin:
              </Typography>
              {brand && (
                <Chip
                  label={brand}
                  sx={{
                    backgroundColor: '#F44336',
                    color: '#FFF',
                    borderRadius: '16px',
                    ml: 2,
                  }}
                />
              )}
            </Box>

            <Box display="flex" justifyContent="center" gap={8}>
              {ALL_IN_ONE_REGIONS.map((region) => (
                <Box key={region}>{renderSection(region)}</Box>
              ))}
            </Box>

            <Box
              sx={{
                height: '1px',
                backgroundColor: 'black',
                opacity: 1,
                mt: 2,
                mb: 2,
              }}
            />
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default DentinLayerAdvice
